export const getOptions = (list = [], fieldUsedLikeValue) => {
  return list.map((element) => {
    const text = element.name.concat('-').concat(element.description);
    const value = fieldUsedLikeValue === 'completeName' ? text : element[fieldUsedLikeValue];
    return {text, value};
  });
};

export const getLimitedOptions = (list = [], fieldUsedLikeValue, limit = 20) => {
  return list.map((element) => {
    const text = element.name.concat('-').concat(element.description);
    const value = fieldUsedLikeValue === 'completeName' ? text : element[fieldUsedLikeValue];
    const limitedValue = value && value.length > limit ? value.substring(0, limit) : value;
    return {text, 'value': limitedValue};
  });
};

export const getClassWithSubClass = (list = [], fieldUsedLikeValue) => {
  return list.map((element) => {
    const text = element.segment.concat(' - ').concat(element.subsegment);
    const value = fieldUsedLikeValue === 'completeName' ? text : (element[fieldUsedLikeValue]).toString();
    return {text, value};
  });
};
